import { createAsyncThunk } from "@reduxjs/toolkit";
import { brandingRequest, instanceRequest } from "../../apiClient/brandingRequests";
import { sanitizeBrandingConfig } from "./brandingUtils";

const httpStatus = (err) =>
  err?.response?.status ?? err?.status ?? err?.code ?? 0;

const httpDetail = (err) =>
  err?.response?.data ?? err?.message ?? "Unknown error";

export const instanceRequestThunk = createAsyncThunk('branding/instance', async () => {
  const response = await instanceRequest();
  return response.data.enabled ? sanitizeBrandingConfig(response.data.branding) : null;
});

export const brandingRequestThunk = createAsyncThunk(
  "branding/request",
  async (_, thunkAPI) => {
    const instance = thunkAPI.getState()?.branding?.instanceConfig;
    if (instance) return instance;
    try {
      const response = await brandingRequest(thunkAPI);
      return thunkAPI.fulfillWithValue(sanitizeBrandingConfig(response.data));
    } catch (err) {
      return thunkAPI.rejectWithValue({
        http_status_code: httpStatus(err),
        detail: httpDetail(err),
      });
    }
  }
);
